import React, { Component } from 'react';
export default class Portfolio extends Component {
  render() {
    return (
      <React.Fragment>
                {/* Portfolio Section
   ================================================== */}
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>Check Out Some of My Projects.</h1>
            {/* portfolio-wrapper */}
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-01" title>
                    <img alt src="images/portfolio/cctv.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>Aggression Detection</h5>
                        <p>Computer Vision and Machine Learning</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-02" title>
                    <img alt src="images/portfolio/milk.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>GenIoT</h5>
                        <p>IoT Coaster using Bluetooth LE</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-03" title>
                    <img alt src="images/portfolio/chinchin.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>Chin Chin</h5>
                        <p>Information retrieval chatbot</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-04" title>
                    <img alt src="images/portfolio/threshold.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>Automatic color threshold</h5>
                        <p>Color thresholding with feedback loop, computer vision</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-05" title>
                    <img alt src="images/portfolio/word.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>200x200 word search generator</h5>
                        <p>Algorithms and web serving</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-06" title>
                    <img alt src="images/portfolio/address.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>Corporate address book</h5>
                        <p>Java software engineering project</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}

              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-07" title>
                    <img alt src="images/portfolio/tinct.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>Tinct</h5>
                        <p>iOS app for clothes matching</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}

              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#modal-08" title>
                    <img alt src="images/portfolio/vincent.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>Vincent</h5>
                        <p>Search and rescue robot</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div> {/* item end */}



            </div> {/* portfolio-wrapper end */}
          </div> {/* twelve columns end */}
          {/* Modal Popup
	      --------------------------------------------------------------- */}
          <div id="modal-01" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-cctv.jpg" alt />
            <div className="description-box">
              <h4>Crime and aggression detection (Top 8 prize)</h4>
              <p>Developed a Crime Detection program with weapon recognition and aggression detection. This project was inspired to automate surveillance especially in public spaces reducing the need for a 24/7 human operator and providing a real-time solution to detecting criminal activities. <br/>
              Role:<br/>
              - Designed the knife detector using tensorflow and a single shot detector <br/>
              - Implemented optical flow to detect signs of aggression
              </p>
              <span className="categories"><i className="fa fa-tag" />Machine Learning, Computer Vision</span>
            </div>
            <div className="link-box">
              <a href="https://devpost.com/software/crime-detect">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-01 End */}

          <div id="modal-02" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-milk.jpg" alt />
            <div className="description-box">
              <h4>GenIoT (Best hardware hack)</h4>
              <p>Picture this, going to the supermarket to buy a fresh carton of milk just to realise that you already have one full carton in your fridge. Now you regret buying the new carton of milk because you won't be able to finish both within the week.<br/>
              We've designed a Bluetooth enabled coaster and a Raspberry PI hub which can communicate with multiple coasters. The reason why we're using Bluetooth is because of it's speed in reacquiring connection. This is based on the assumption that a fridge acts as a faraday cage thus no signal can pass thru and also that the contents of any food product only changes when a user opens the fridge and consumes it. It is within this small time frame that the coaster will communicate and update the server.<br/>
              Role: <br/>
              - Wrote RPi server code in javascript using NodeJS to support Eddystone TLM<br/>
              - Created iOS example application
              </p>
              <span className="categories"><i className="fa fa-tag" />iOS Development, BluetoothLE Protocol, NodeJS backend</span>
            </div>
            <div className="link-box">
              <a href="https://devpost.com/software/geniot">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-02 End */}
          <div id="modal-03" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-chinchin.jpg" alt />
            <div className="description-box">
              <h4>Chin Chin</h4>
              <p>Released a blank slate chatbot as a telegram bot to my group of friends. Became extremely.. "corrupted" in a week's time. Built with Python AIOHTTP and a seq2seq model. Served with React and Telegram</p>
              <span className="categories"><i className="fa fa-tag" />Chatbot, Telegrambot, React</span>
            </div>
            <div className="link-box">
              <a href="http://chinchin.link">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-03 End */}
          <div id="modal-04" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-threshold.jpg" alt />
            <div className="description-box">
              <h4>Automatic color thresholding</h4>
              <p>Created a automatic thresholding alogrithm which tunes and thresholds according to the closest sample color we want. Designed this because I was really lazy after constantly tuning 6 parameters of the LAB color space thresholds during Robosub 2018.</p>
              <span className="categories"><i className="fa fa-tag" />Computer Vision, Robotics</span>
            </div>
            <div className="link-box">
              <a href="https://github.com/lws803/threshold_cv/blob/master/Research/k_nearest_detector_v2/k_nearest_detector_v2/main.cpp">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-04 End */}
          <div id="modal-05" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-word.jpg" alt />
            <div className="description-box">
              <h4>Word search generator</h4>
              <p>This one was pretty interesting. It started out when I invited a group of friends to help me solve the world's largest cross word. To my surprise, none of my friends wanted to play the game consoles but rather tried their best to solve it for a few hours straight! Inspired by their dedication, I decided to make a cross word generator where you could customise the words you wish to appear. An answer key would also be provided. <br/>
              Guess this would make a good birthday present.</p>
              <span className="categories"><i className="fa fa-tag" />React, Python</span>
            </div>
            <div className="link-box">
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-05 End */}
          <div id="modal-06" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-address.jpg" alt />
            <div className="description-box">
              <h4>Corporate address book</h4>
              <p>
                As part of our Software Engineering class, we are told to build a java application to manage contacts. We were told to build on top of an already existing address book by SE-EDU. Our enhacements include: <br/>
                - Auto complete feature <br/>
                - Boolean retrieval search <br/>
                - Encryption/ decryption <br/>
                - Import/ export <br/>
                - Sorting
              </p>
              <span className="categories"><i className="fa fa-tag" />Java, Javafx, Git</span>
            </div>
            <div className="link-box">
              <a href="https://github.com/CS2113-AY1819S1-W12-3/main">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-06 End */}

          <div id="modal-07" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/tinct-m.jpg" alt />
            <div className="description-box">
              <h4>Tinct</h4>
              <p>
              Designed a clothes matching app based on color matching. App uses several instagram feeds on outfit grids to create a library of different outfits. Users of the app can like and state their preferences of the outfit grids. <br/> 
              These user preferences are stored in Firebase database and the color search algorithm uses euclidean distances in LAB color space.
              </p>
              <span className="categories"><i className="fa fa-tag" />Swift, iOS, Cocoapods, Firebase, computer vision, sketch</span>
            </div>
            <div className="link-box">
              <a href="https://itunes.apple.com/us/app/tinct-project/id1187295846?mt=8">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-07 End */}

          <div id="modal-08" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-vincent.jpg" alt />
            <div className="description-box">
              <h4>Vincent</h4>
              <p>
                Created a robot with SLAM (simultaneous localisation and mapping) capabilities for a course module. Our task was to navigate an unknown maze using teleoperation and perform autonomous backtracking to the start after reaching our destination. <br/>
                Role:<br/>
                - Implemented the A* path finding algorthim for autonomous backtracking <br/>
                - Implemented the global marker stack (details in the journal report) for Vincent
              </p>
              <span className="categories"><i className="fa fa-tag" />ROS, SLAM</span>
            </div>
            <div className="link-box">
              <a href="resources/vincentJournal.pdf">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>{/* modal-08 End */}


        </div> {/* row End */}
      </section> {/* Portfolio Section End*/}

      </React.Fragment>
    );
  }
}
